import { Pagination, Stack } from "@mui/material";
import { theme } from "../../../theme";

const PaginationView = ({undecidedRequests, page, setPage}) => {
    return(
        <>
            {!undecidedRequests.loading && (
                <Stack 
                    spacing={2} 
                    className="mb-3" 
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center'
                    }}      
                >
                    <Pagination 
                        count={undecidedRequests.totalPages} 
                        page={page} 
                        onChange={(event, newPage) => setPage(newPage)}
                        color={theme.main}
                    />
                </Stack>
            )}
        </>
    );
}

export default PaginationView;